import Pagination from '../rc-components/pagination/locale/zh_TW';
import Cascader from '../rc-components/cascader/locale/zh_TW';
import DatePicker from '../date-picker/locale/zh_TW';
import TimePicker from '../time-picker/locale/zh_TW';
import Calendar from '../calendar/locale/zh_TW';
export default {
    locale: 'zh-tw',
    Pagination,
    DatePicker,
    TimePicker,
    Calendar,
    Cascader,
    Table: {
        filterTitle: '篩選器',
        filterConfirm: '確 定',
        filterReset: '重 置',
        emptyText: '目前尚無資料',
        selectAll: '全部選取',
        selectInvert: '反向選取',
    },
    Modal: {
        okText: '確 定',
        cancelText: '取 消',
        justOkText: '確 定',
    },
    Popconfirm: {
        okText: '確 定',
        cancelText: '取 消',
    },
    Transfer: {
        notFoundContent: '查無此資料',
        searchPlaceholder: '搜尋資料',
        itemUnit: '項目',
        itemsUnit: '項目',
    },
    Select: {
        notFoundContent: '查無此資料',
    },
    Upload: {
        uploading: '正在上傳...',
        removeFile: '刪除檔案',
        uploadError: '上傳失敗',
        previewFile: '檔案預覽',
    },
    Collapse: {
        fold: '收起',
        unfold: '展开',
    },
    imageCrop: {
        editImage: '編輯圖片',
        avatarUploadError: '頭像上傳失敗',
        avatarServerError: '服務器錯誤',
        avatarUpload: '頭像上傳',
        avatarReminder: '你可以在此裁剪、旋轉圖片、然後點擊“保存”完成頭像的修改',
        preview: '預覽',
        reUpload: '重新上傳',
        imageTooLarge: '圖片過大，請重新上傳',
        imageUploadError: '圖片上傳錯誤',
        imageDragHere: '圖片請拖拽到這裏',
        pleaseUpload: '請上傳小於',
        uploadType: '文件類型爲',
        picture: '的圖片',
        cancelButton: '取消',
        saveButton: '保存',
        changeAvatar: '修改頭像',
    },
    PerformanceTable: {
        emptyMessage: '暂无数据',
        loading: '加載中…',
    },
};
